import { render, staticRenderFns } from "./ListUrbanPlagas.vue?vue&type=template&id=75d9a383&scoped=true"
import script from "./ListUrbanPlagas.vue?vue&type=script&lang=js"
export * from "./ListUrbanPlagas.vue?vue&type=script&lang=js"
import style0 from "./ListUrbanPlagas.vue?vue&type=style&index=0&id=75d9a383&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d9a383",
  null
  
)

export default component.exports